var map = {
	"./add-to-cart.png": 4836,
	"./cart-logo.svg": 6767,
	"./cc-placeholder.png": 1254,
	"./maestro-logo.png": 499,
	"./mastercard-logo.png": 5908,
	"./posters/15dy2067ms/15dy2067ms-2.jpeg": 6403,
	"./posters/15dy2067ms/15dy2067ms-3.jpg": 6412,
	"./posters/15dy2067ms/15dy2067ms-4.jpg": 7160,
	"./posters/15dy2067ms/15dy2067ms.jpeg": 4407,
	"./posters/8I/8i-2.jpeg": 3479,
	"./posters/8I/8i-3.jpeg": 3308,
	"./posters/8I/8i.jpeg": 1700,
	"./posters/A12/a12-2.jpeg": 9673,
	"./posters/A12/a12-3.jpg": 8340,
	"./posters/A12/a12.jpeg": 9443,
	"./posters/A32/a32-2.jpeg": 5638,
	"./posters/A32/a32-3.jpeg": 8386,
	"./posters/A32/a32.jpeg": 8993,
	"./posters/A50/a50.jpeg": 4965,
	"./posters/A70/a70-2.jpeg": 8985,
	"./posters/A70/a70-3.jpg": 4229,
	"./posters/A70/a70.jpeg": 3210,
	"./posters/A80/a80-2.jpeg": 6877,
	"./posters/A80/a80-3.jpeg": 7921,
	"./posters/A80/a80.jpeg": 5007,
	"./posters/A90/a90.jpeg": 6280,
	"./posters/Aspire3/aspire3-2.jpeg": 6441,
	"./posters/Aspire3/aspire3-3.jpg": 6838,
	"./posters/Aspire3/aspire3.jpeg": 6933,
	"./posters/GalaxyTabA7/galaxytaba7-2.jpeg": 2779,
	"./posters/GalaxyTabA7/galaxytaba7-3.jpeg": 6117,
	"./posters/GalaxyTabA7/galaxytaba7.jpeg": 1041,
	"./posters/Honor70/honor70-2.jpeg": 1732,
	"./posters/Honor70/honor70-3.jpeg": 309,
	"./posters/Honor70/honor70.jpeg": 9097,
	"./posters/HonorX8/honorX8-2.jpeg": 5123,
	"./posters/HonorX8/honorX8-3.jpeg": 1330,
	"./posters/HonorX8/honorX8.jpeg": 155,
	"./posters/IPad10/IPad10-2.jpeg": 4285,
	"./posters/IPad10/IPad10.jpeg": 7560,
	"./posters/IdeaPad3/ideapad3-2.jpeg": 6812,
	"./posters/IdeaPad3/ideapad3-3.jpeg": 7342,
	"./posters/IdeaPad3/ideapad3.jpeg": 2108,
	"./posters/IdeaPad5/ideapad5-2.jpeg": 8720,
	"./posters/IdeaPad5/ideapad5-3.jpeg": 9676,
	"./posters/IdeaPad5/ideapad5.jpeg": 9029,
	"./posters/Iphone12/Iphone12-2.jpeg": 5431,
	"./posters/Iphone12/Iphone12-3.jpeg": 8781,
	"./posters/Iphone12/Iphone12.jpeg": 6800,
	"./posters/Iphone13/iphone13-2.jpeg": 8144,
	"./posters/Iphone13/iphone13.jpeg": 1519,
	"./posters/Iphone7/Iphone7.jpeg": 516,
	"./posters/M10/M10-2.jpeg": 2477,
	"./posters/M10/M10-3.jpeg": 5948,
	"./posters/M10/M10.jpeg": 9326,
	"./posters/MacbookAir13/macbookair13-2.jpeg": 8763,
	"./posters/MacbookAir13/macbookair13.jpeg": 8425,
	"./posters/Mate50P/mate50p-2.jpeg": 7219,
	"./posters/Mate50P/mate50p.jpeg": 2753,
	"./posters/MateBookD15/matebookd15-2.jpeg": 5259,
	"./posters/MateBookD15/matebookd15-3.jpeg": 2279,
	"./posters/MateBookD15/matebookd15.jpeg": 2092,
	"./posters/MatePadT10S/matepadt10s-2.jpeg": 7128,
	"./posters/MatePadT10S/matepadt10s-3.jpeg": 7764,
	"./posters/MatePadT10S/matepadt10s.jpeg": 6737,
	"./posters/P12/P12-2.jpeg": 9811,
	"./posters/P12/P12.jpeg": 5450,
	"./posters/Pad8/Pad8-2.jpeg": 8043,
	"./posters/Pad8/Pad8.jpeg": 1474,
	"./posters/Pixel5/pixel5-2.jpeg": 6150,
	"./posters/Pixel5/pixel5-3.jpeg": 7243,
	"./posters/Pixel5/pixel5.jpeg": 2571,
	"./posters/Pixel6pro/pixel6pro-2.jpeg": 733,
	"./posters/Pixel6pro/pixel6pro-3.jpeg": 3083,
	"./posters/Pixel6pro/pixel6pro.jpeg": 5318,
	"./posters/PocoX3/pocoX3-2.jpeg": 4154,
	"./posters/PocoX3/pocoX3-3.jpeg": 715,
	"./posters/PocoX3/pocoX3.jpeg": 6342,
	"./posters/PocoX4/pocox4-2.jpeg": 4685,
	"./posters/PocoX4/pocox4.jpeg": 9461,
	"./posters/Probook455/probook455-2.jpeg": 7555,
	"./posters/Probook455/probook455.jpeg": 3086,
	"./posters/Redmi10C/redmi10c-2.jpeg": 4913,
	"./posters/Redmi10C/redmi10c.jpeg": 4449,
	"./posters/RedmiNote11/redmiNote11-2.jpeg": 764,
	"./posters/RedmiNote11/redmiNote11.jpeg": 6769,
	"./posters/S20/s20-2.jpeg": 9997,
	"./posters/S20/s20-3.jpeg": 9082,
	"./posters/S20/s20.jpeg": 2377,
	"./posters/S21/s21-2.jpeg": 9498,
	"./posters/S21/s21-3.jpeg": 9031,
	"./posters/S21/s21.jpeg": 586,
	"./posters/Xperia5/xperia5-2.jpeg": 4588,
	"./posters/Xperia5/xperia5-3.jpeg": 4453,
	"./posters/Xperia5/xperia5.jpeg": 8271,
	"./posters/Y21/y21-2.jpeg": 3874,
	"./posters/Y21/y21-3.jpeg": 9434,
	"./posters/Y21/y21.jpeg": 583,
	"./posters/Y31/Y31-3.jpeg": 121,
	"./posters/Y31/y31-2.jpeg": 3240,
	"./posters/Y31/y31.jpeg": 5437,
	"./posters/YogaTab11/yogatab11-2.jpeg": 5647,
	"./posters/YogaTab11/yogatab11.jpeg": 2880,
	"./rs_school_js.svg": 6395,
	"./visa-logo.png": 2743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;